import { motion } from "framer-motion";

function TestimonialsSection() {
  const testimonials = [
    {
      quote: "MailMaid has completely transformed how I manage my inbox. What used to take hours now takes minutes. The AI prioritization is incredibly accurate.",
      name: "Sarah Johnson",
      title: "Marketing Director",
      company: "TechCorp",
      avatar: "/api/placeholder/64/64",
    },
    {
      quote: "As someone who receives hundreds of emails daily, MailMaid has been a game-changer for my productivity. The email summarization feature alone pays for itself.",
      name: "Michael Chen",
      title: "Product Manager",
      company: "Innovate Inc",
      avatar: "/api/placeholder/64/64",
    },
    {
      quote: "Our entire team now uses MailMaid. The smart categorization and shared inbox features have improved our client response time by 40%. Worth every penny!",
      name: "Elena Rodriguez",
      title: "CEO",
      company: "Growth Ventures",
      avatar: "/api/placeholder/64/64",
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 300
      }
    }
  };

  return (
    <section className="py-20 px-4 bg-[#fff5eb]">
      <div className="container mx-auto max-w-6xl">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#694e42]">What Our Users Say</h2>
          <p className="text-lg text-[#8a7266] max-w-2xl mx-auto">
            Join thousands of professionals who have transformed their email workflow with MailMaid.
          </p>
        </motion.div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={index} 
              className="bg-white p-8 rounded-xl shadow-md border border-[#e2dad3]"
              variants={itemVariants}
              whileHover={{ 
                y: -10, 
                boxShadow: "0 20px 30px rgba(0, 0, 0, 0.07)",
                transition: { duration: 0.3 } 
              }}
            >
              <div className="flex items-center mb-6">
                <svg className="w-8 h-8 text-[#ff8c42]" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
              </div>
              <p className="text-[#694e42] mb-8 italic">{testimonial.quote}</p>
              <div className="flex items-center mt-auto">
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.name} 
                  className="w-12 h-12 rounded-full mr-4 border-2 border-[#ff8c42]"
                />
                <div>
                  <h4 className="font-bold text-[#694e42]">{testimonial.name}</h4>
                  <p className="text-[#8a7266] text-sm">{testimonial.title}, {testimonial.company}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          className="mt-16 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <motion.button
            className="px-8 py-3 bg-[#ff8c42] text-white rounded-md font-medium shadow-md"
            whileHover={{ scale: 1.05, boxShadow: "0 10px 15px rgba(255, 140, 66, 0.2)" }}
            whileTap={{ scale: 0.95 }}
          >
            Read More Success Stories
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
}

export default TestimonialsSection;